export default __webpack_public_path__ + "static/media/pic10.20e0f4a3.jpg";